export class Field {
    id?: number = 0;
    user_id?: number = 0;
    name?: string | null = '';
    location?: string | null = '';
    geo_json: string = '';
    features: any[] = [];
    source_format?: string | null = null;
    source_meta?: string | null = null;
    created_at?: string = '';
    updated_at?: string = '';
}
